export const PAYMENT_STEPS = ["detail", "bank", "account"] as const;

export type PaymentStep = (typeof PAYMENT_STEPS)[number];

/**
 * ?step= value for each step — `detail` is the default and has none.
 * These strings are a wire contract: the backend redirects to
 * ?step=BankAccountSelect after bank auth (ProcessCallbackCommand.cs),
 * so they can't be renamed to match the step names.
 */
export const PAYMENT_STEP_URL_PARAMS = {
  detail: undefined,
  bank: "BankSelect",
  account: "BankAccountSelect",
} as const satisfies Record<PaymentStep, string | undefined>;

export const getPaymentStepByUrlParam = (urlParam: string | null) =>
  PAYMENT_STEPS.find(
    (step) => !!urlParam && PAYMENT_STEP_URL_PARAMS[step] === urlParam,
  );
